import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import { PASSWORD_TOO_SHORT, newPasswordSchema } from '@dashboard/components/AuthForm';

import { resetPassword } from './helpers';

import AccountResetPassword from './AccountResetPassword';

const propTypes = {
  match: PropTypes.object.isRequired,
};

class AccountResetPasswordContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        state: {
          password: '',
        },
        saved: false,
        message: '',
        linkExpired: false,
      },
    };
  }

  handleInputChange = e => {
    const { target } = e;

    const newState = update(this.state, {
      form: {
        state: {
          [target.name]: {
            $set: target.value,
          },
        },
      },
    });

    this.setState(newState);
  };

  showError = (message, linkExpired = false) => {
    this.setState(prev =>
      update(prev, {
        form: {
          message: { $set: message },
          linkExpired: { $set: linkExpired },
          saved: { $set: false },
        },
      }),
    );
  };

  handleSubmit = async e => {
    e.preventDefault();
    if (this.inFlight) return;

    this.inFlight = true;
    this.setState({ submitting: true });
    try {
      await this.submit(e);
    } finally {
      this.inFlight = false;
      this.setState({ submitting: false });
    }
  };

  submit = async e => {
    const { resetPasswordToken } = this.props.match.params;
    const {
      form: { state },
    } = this.state;

    e.preventDefault();

    if (!state.password || !state.password.length) {
      return this.showError('You need to supply a new password!');
    }

    if (!newPasswordSchema.isValidSync({ password: state.password })) {
      return this.showError(PASSWORD_TOO_SHORT);
    }

    if (!resetPasswordToken || !resetPasswordToken.length) {
      return this.showError('Password reset token invalid. Please request a new token.', true);
    }

    const submittedPasswordReset = await resetPassword({ ...state }, resetPasswordToken);

    if (!submittedPasswordReset) {
      return this.showError(
        'Something went wrong. If this error persists, please contact support.',
      );
    }

    if (submittedPasswordReset.message) {
      return this.showError(
        submittedPasswordReset.message,
        submittedPasswordReset.meta?.status === 403,
      );
    }

    this.setState(prev =>
      update(prev, {
        form: { saved: { $set: true }, message: { $set: '' }, linkExpired: { $set: false } },
      }),
    );
  };

  render() {
    return (
      <AccountResetPassword
        form={this.state.form}
        handleInputChange={this.handleInputChange}
        handleSubmit={this.handleSubmit}
        submitting={!!this.state.submitting}
      />
    );
  }
}

AccountResetPasswordContainer.propTypes = propTypes;

export default AccountResetPasswordContainer;
